export enum ClinicsForms {
  Profile = 'Profile',
  Address = 'Address',
  Contacts = 'Contacts',
  Payment = 'Payment',
  Schedule = 'Schedule',
  Insurance = 'Insurance',
  FAQs = 'FAQs',
}
